module.exports = __webpack_public_path__ + "img/club.fd285ca6.png";